if (!customElements.get('anniversary-jump-nav')) {
    class AnniversaryJumpNav extends HTMLElement {
        constructor() {
            super();
            // 判断是否开启跳转功能
            this.jumpAction = this.dataset.function === 'true';
            // console.log('Anniversary12thNav 构造函数:', {
            //     element: this,
            //     dataset: this.dataset,
            //     jumpAction: this.jumpAction
            // });
        }

        connectedCallback() {
            // console.log('Anniversary12thNav connectedCallback:', {
            //     jumpAction: this.jumpAction
            // });
            if (!this.jumpAction) {
                // console.log('跳转功能未启用，退出初始化');
                return;
            }
            this.initNav();
        }

        initNav() {
            this.addEventListener('click', (e) => {
                if (e.target.closest('.anniversary-13th-sticky__top')) {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    return;
                }
                const item = e.target.closest('[data-jump]');
                if (!item || !this.contains(item)) return;
                this.jumpFunction(item);
            });
            this.initStickyState();
            this.initStickyFooterClamp();
        }
        jumpFunction(target) {
            const targetData = target.dataset.jump;
            // console.log('执行跳转函数:', {
            //     target: target,
            //     targetData: targetData
            // });
            // targetEl 为data-jump-id等于targetData的元素
            const targetEl = document.querySelector(`[data-jump-id="${targetData}"]`);
            // console.log('目标元素:', {
            //     selector: `[data-jump-id="${targetData}"]`,
            //     found: !!targetEl,
            //     element: targetEl
            // });
            if (!targetEl) {
                // console.warn('未找到目标跳转元素，跳转取消');
                return;
            }
            // 滚动到targetEl
            // console.log('滚动到目标元素');
            targetEl.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
        initStickyState() {
            const stops = Array.from(this.querySelectorAll('.anniversary-13th-sticky__stop'));
            if (!stops.length) return;

            const mark = () => {
                const line = Math.min(window.innerHeight * 0.35, 220);
                let current = stops[0];
                stops.forEach((stop) => {
                    const id = stop.dataset.jump;
                    if (!id) return;
                    const el = document.querySelector(`[data-jump-id="${id}"]`);
                    if (!el) return;
                    if (el.getBoundingClientRect().top <= line) current = stop;
                });
                stops.forEach((stop) => {
                    const active = stop === current;
                    stop.classList.toggle('is-active', active);
                    if (active) {
                        stop.setAttribute('aria-current', 'true');
                    } else {
                        stop.removeAttribute('aria-current');
                    }
                });
            };

            mark();
            window.addEventListener('scroll', mark, { passive: true });
            window.addEventListener('resize', mark);
        }
        initStickyFooterClamp() {
            const shell = this.querySelector('.anniversary-13th-sticky-shell');
            const sticky = this.querySelector('.anniversary-13th-sticky');
            if (!shell || !sticky) return;

            const footer =
                document.querySelector('footer.footer') || document.querySelector('footer');
            if (!footer) return;

            const gap = 16;
            const update = () => {
                const currentShift =
                    parseFloat(getComputedStyle(shell).getPropertyValue('--sticky-shift')) || 0;
                const unshiftedBottom = sticky.getBoundingClientRect().bottom - currentShift;
                const overlap = unshiftedBottom + gap - footer.getBoundingClientRect().top;
                shell.style.setProperty(
                    '--sticky-shift',
                    overlap > 0 ? `${-overlap}px` : '0px'
                );
            };

            update();
            window.addEventListener('scroll', update, { passive: true });
            window.addEventListener('resize', update);
        }
    }
    customElements.define('anniversary-jump-nav', AnniversaryJumpNav);
    // console.log('AnniversaryJumpNav 组件已注册');
}